// no-export
import { Registry } from "yinzcam-registry";
import { YinzCamAppServer } from "./YinzCamAppServer";

export const APP_SERVER_REGISTRY: Registry<YinzCamAppServer> = new Registry<YinzCamAppServer>('APP_SERVER_REGISTRY');
